import React, { useState, /* useRef */ } from "react";
import { /* Link */ } from "react-router-dom";
import { Users, Heart, Award,/*  X, */ } from "lucide-react";
import { TeamsPageSEO } from "../components/SEO";
import "./TeamsPage.css";

export default function TeamsPage() {
  const [/* selectedImage */, setSelectedImage] = useState(null);
  

  // Helper function to generate image arrays
  const generateImages = (folder, count, startNum = 1, extension = 'jpg') => {
    return Array.from({ length: count }, (_, index) => {
      const imageNum = startNum + index;
      return {
        id: `${folder}-${imageNum}`,
        src: `${folder}/${imageNum}.${extension}`,
        alt: `${folder} ${imageNum}`
      };
    });
  };


  const galleries = [
    {
      id: 1,
      title: "Our Promotions",
      description: "Showcasing our latest offers and achievements",
      color: "blue",
      images: generateImages('Promos', 90, 1) // Promos folder: 1.jpg to 88.jpg
    },
    {
      id: 2,
      title: "Team Building & Events",
      description: "Celebrating together and building strong bonds",
      color: "purple",
      images: [
       
        ...generateImages('Team Building', 80, 1), // Adjust count and start number as needed
        
        
      ]
    },
  ];

  

  return (
    <div className="teams-page">
      <TeamsPageSEO />
      
  {/* Gallery Sections */}
  <section className="galleries-section">
  <div className="container">
    {galleries.map((gallery) => (
      <div key={gallery.id} className="gallery-block">

        {/* Header */}
        <div className="gallery-header">
          <h2 className="gallery-title">{gallery.title}</h2>
          <p className="gallery-description">{gallery.description}</p>
        </div>

        {/* Image Grid */}
        <div className="image-grid">
          {gallery.images.map((image) => (
            <div
              key={image.id}
              className="image-grid-item"
              onClick={() => setSelectedImage(image)}
            >
              <img src={image.src} alt={image.alt} loading="lazy" />
            </div>
          ))}
        </div>

      </div>
    ))}
  </div>
</section>

      {/* Culture Values Section */}
      <section className="culture-values">
        <div className="container">
          <h2 className="section-title">What Drives Us</h2>
          <div className="values-grid">
            <div className="value-card">
              <Heart className="value-icon" />
              <h3>Passion</h3>
              <p>We're passionate about delivering excellence in everything we do</p>
            </div>
            <div className="value-card">
              <Users className="value-icon" />
              <h3>Teamwork</h3>
              <p>Together, we achieve more and create lasting relationships</p>
            </div>
            <div className="value-card">
              <Award className="value-icon" />
              <h3>Excellence</h3>
              <p>We strive for excellence in customer service and team performance</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-teams">
        <div className="container">
          <h2>Join Our Growing Team</h2>
          <p>Be part of a culture where teamwork, excellence, and passion thrive</p>
        </div>
      </section>
      
    </div>
  );
}